import { render } from "./TransmissionPatient.vue?vue&type=template&id=8d6717c4"
import script from "./TransmissionPatient.vue?vue&type=script&lang=js"
export * from "./TransmissionPatient.vue?vue&type=script&lang=js"

import "./TransmissionPatient.vue?vue&type=style&index=0&id=8d6717c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__